define.alias("shared/components/shared/asset-upload", "media/components/shared/asset-upload");